import { useInputHelper, EnumDropdown, DefaultInputPropTypes, TextInput } from 'framework/form';
import React, { useEffect } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { ADDITIONAL_CONTACTS_OPTIONS } from './useAdditionalContactsHelper';

const AdditionalContactInput = (props: DefaultInputPropTypes<unknown>) => {
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const onChangeCallback = getRawOnChangeCallback() || (() => {});

  const additionalContact = getValue() || {};

  useEffect(() => {
    if (!getValue()) {
      onChangeCallback({
        [getSource()]: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const typeSource = `${getSource()}.type`;
  const valueSource = `${getSource()}.value`;

  const typeOnChangeCallback = (obj: { [x: string]: any }) => {
    onChangeCallback({
      [getSource()]: {
        ...additionalContact,
        type: obj[typeSource],
      },
    });
  };

  const valueOnChangeCallback = (obj: { [x: string]: any }) => {
    onChangeCallback({
      [getSource()]: {
        ...additionalContact,
        value: obj[valueSource],
      },
    });
  };

  return (
    <Grid container spacing={2} sx={{ maxWidth: { lg: 'calc(50% + 8px)' } }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <EnumDropdown
          source={typeSource}
          label="Type"
          value={additionalContact.type}
          onChangeCallback={typeOnChangeCallback}
          options={ADDITIONAL_CONTACTS_OPTIONS}
          placeholder="Social link type"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput
          source={valueSource}
          label="Value"
          value={additionalContact.value}
          onChangeCallback={valueOnChangeCallback}
          placeholder="Social link"
        />
      </Grid>
    </Grid>
  );
};

export default AdditionalContactInput;
